import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ModalDataState {
  authorCollections: any;
}

const initialState: ModalDataState = {
  authorCollections: [],
};

// check this func 
export const setAdditionalKeys:any = createAsyncThunk(
    'authorCollections/setAdditionalKeys',
    async (thisData:any, { getState, dispatch }) => {
    let state:any = getState();
    let {likedCollections, dislikedCollections, userBookmarks} = state.publicCollectionsData;
    let {authorCollections} = state.publicPageData;
    let {isLogin} = state.userActions;

    let data = thisData ?? authorCollections;

  
  
      if (!isLogin) {
        let newUpdatedCollections = data.map((collection:any) => {
          const votes = collection.details.likes - collection.details.dislikes;
          return {
            ...collection,
            votes: votes,
          };
        });

        
        dispatch(updateAuthorCollections({data: newUpdatedCollections, apiCall : thisData ? true : false}))
    } else {
        console.log("it RUN")
        let newUpdatedCollections =  data?.map((collection:any) => {
          const votes = collection?.details.likes - collection.details.dislikes;
          const isLiked = likedCollections?.includes(collection.id);
          const isDisliked = dislikedCollections?.includes(collection.id);
          const isBookmarked = userBookmarks?.hasOwnProperty(collection.id) ? userBookmarks[collection.id] : false;
          
          return {
            ...collection,
            ...(thisData ? { votes: votes } : {}),
            liked: isLiked,
            disliked: isDisliked,
            bookmarked: isBookmarked
          };
        })
          console.log(newUpdatedCollections, 'COLLECTINO IN SET ')
        
        dispatch(updateAuthorCollections({data: newUpdatedCollections, apiCall : thisData ? true : false}))

      }
    }
  );

const publicPageDataSlice = createSlice({
  name: 'publicPageData',
  initialState,
  reducers: {
    updateAuthorCollections: (state, action: PayloadAction<any>) => {
        if (action.payload?.apiCall){
            state.authorCollections = [...state.authorCollections, ...action.payload?.data]
        }
        else {
            state.authorCollections = action.payload?.data;
        }
        // console.log(action.payload.apiCall, 'API CALL')
      console.log(state.authorCollections, 'state')
      console.log(action.payload.data, 'payload')
    },
    
  },
});

export const { updateAuthorCollections } = publicPageDataSlice.actions;
export default publicPageDataSlice.reducer;
